export default {
  PAY_SLIP: 'paySlip',
  NEXT_PAY_SLIP: 'nextPaySlip',
  INVOICE: 'invoice',
  ACCOUNTING_VOUCHER: 'accountingVoucher',
}
